import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import Form from '../components/forms/form';

function init() {
  const $forms = $('.qpb-form');

  $forms.each(function() {
    const $form = $(this);
    const formId = $form.data('form-base-id');
    const tag = $form.data('tag');
    const contentArticleFormId = $form.data('content-article-form-id');
    const sugarEventId = $form.data('sugar-event-id'); 

    if (!formId || !contentArticleFormId) {
      ReactDOM.render(<div>Kein Formular angegeben</div>, $form[0]);
      return;
    }

    ReactDOM.render(
      <Form formId={formId} contentArticleFormId={contentArticleFormId} sugarEventId={sugarEventId} tag={tag} />,
      $form[0]
    );
  });
}

export { init };



// WEBPACK FOOTER //
// ./webflow_forms/init.js